export default __webpack_public_path__ + "static/media/buffet.b541e0b3.png";